$( document ).ready(function() {
  
//   Get the width of the dropdown link and set the dropdown width to be at least that width
var linkWidth = $('.site-nav--has-dropdown').width();
$('.site-nav--has-dropdown .site-nav__dropdown').css('min-width', linkWidth);
console.log(linkWidth);
  });